import React from 'react';
import { observer } from 'src/utils/mobx-react';

import {
    ItemBetName,
    ItemBetTime,
    NotificationListItem,
} from 'src/components/Header/LHSMenu/NotificationsMenu/NotificationsMenuLists/NotificationsMenuLists.style';
import { BetReferralNotificationType } from 'src_server/types/notificationData';
import { DateTime } from 'src_common/utils/time/time';
import { money } from 'src/utils/format';
import { Button } from 'src/domains/common/components/button/button';
import { useAppStateContext } from 'src/AppState/AppState';

interface NotificationsMenuBetItemType {
    currentStaffAccountId: number | null;
    betReferralNotification: BetReferralNotificationType;
    onAssignTrader: (userId: number, assignee: BetReferralNotificationType['details']['assignee']) => void;
}

export const NotificationsMenuBetsItem = observer(
    'NotificationsMenuBetsItem',
    ({ betReferralNotification, onAssignTrader }: NotificationsMenuBetItemType): JSX.Element | null => {
        const appState = useAppStateContext();
        // const { betReferralNotification } = props;
        const age = DateTime.from(betReferralNotification.createdAt)?.fromNow();
        const { details, status } = betReferralNotification;

        // TO DO ADD BET IS ASSIGNED TO ... YOU CAN USE currentStaffAccountId FROM PROPS

        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        const sports = details.sports ?? [];
        const sportsLabel = sports.length < 2 ? sports[0]?.name : 'Multiple sports';

        const onClick = (): void => {
            onAssignTrader(betReferralNotification.accountId, details.assignee);
            appState.routerBackoffice.redirectToSpecificUserBetslip(betReferralNotification.accountId);
        };

        return (
            <NotificationListItem
                status={status}
                className='rounded-md border border-border border-solid bg-background'
            >
                <ItemBetName className='text-xs text-foreground'>
                    {betReferralNotification.accountName} &nbsp; ({details.stakeFactor})
                </ItemBetName>
                <ItemBetName className='text-xs text-foreground'>
                    {money(details.totalStake, details.currency)} &nbsp; {details.currency}
                </ItemBetName>
                <ItemBetName className='text-xs text-foreground'>{sportsLabel}</ItemBetName>
                <ItemBetTime className='text-muted-foreground text-[0.625rem] leading-[1.40]'>{age}</ItemBetTime>

                <Button
                    variant='outline'
                    className='w-full'
                    type='button'
                    onClick={onClick}
                >
                    View bet
                </Button>
            </NotificationListItem>
        );
    }
);
